<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeIn dura-1">
          <v-flex xs12 sm7 md7 mb-2>
            <div class="cont-num"><p>{{casoNum+1}} / 18</p></div>
          </v-flex>
          <v-flex xs12 sm7 md7>
            <div class="cont-casos">
              <p>{{textCasos.titulo[casoNum]}}</p>
              <p class="desc">( {{textCasos.articulo[casoNum]}} )</p>
              </div>
          </v-flex>
          <v-flex xs12 md7 sm7 mt-2 class="animated fadeInUp dura-3">
            <slide-items-app :slideListElements="slideListB" :slidelength="lengthB" :slideonboarding="onboardingB" @valueSlide="slideNumB = $event">
            </slide-items-app>
          </v-flex>
          <v-flex xs12 md7 sm7 mt-2 class="animated fadeInUp dura-3">
            <slide-items-app :slideListElements="slideListC" :slidelength="lengthC" :slideonboarding="onboardingC" @valueSlide="slideNumC = $event">
            </slide-items-app>
          </v-flex>
          <v-flex xs12 mt-2 class="animated fadeInUp dura-3">
            <button class="btn-white-dark" @click="enviarResultado()"><span>Enviar</span></button>
          </v-flex>

        </v-layout>
        <modal-resultado-app v-model="modalResultado" :nameResult="modalResult" 
        @bienAvanzar="bienAction()">
        </modal-resultado-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Em português existe gênero feminino e masculino no singular e plural, e artigos definidos e indefinidos.',
        'Leia as palavras e clique no artigo correto.'
      ],
      slideListB:['Feminino','Masculino'],
      lengthB: 2,
      onboardingB: 0,
      slideListC:['A','AS','O','OS','UMA','UMAS','UM','UNS'],
      lengthC: 8,
      onboardingC: 0,
      textCasos:{ 
        titulo:[
        'Água', //1
        'Porto', //2
        'Viagem', //3
        'Barco', //4
        'Arte',  //5
        'Computador',  //6
        'Casa',  //7
        'Árvores',  //8
        'Alma',  //9
        'Pontes',  //10
        'Viagem',  //11
        'Estrelas',  //12
        'Aspirador',  //13
        'Computadores',  //14
        'Senhor',  //15
        'Barcos',  //16
        'Caminho',  //17     
        'Paradoxos'  //18
        ],
        articulo:[
          'Definido',
          'Definido',
          'Definido',
          'Definido',
          'Definido',
          'Definido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
          'Indefinido',
        ]
      },
      casoNum:0,
      modalResultado:false,
      modalResult:'mal',
      slideNumB:0,
      slideNumC:0,
      respuestaActual:Array(2).fill('0'),
      respuestasCorrectas:{
        correctas1:['0','0'],
        correctas2:['1','2'],
        correctas3:['0','0'],
        correctas4:['1','2'],
        correctas5:['0','0'],
        correctas6:['1','2'],
        correctas7:['0','4'],
        correctas8:['0','5'],
        correctas9:['0','4'],
        correctas10:['0','5'],
        correctas11:['0','4'],
        correctas12:['0','5'],
        correctas13:['1','6'],
        correctas14:['1','7'],
        correctas15:['1','6'],
        correctas16:['1','7'],
        correctas17:['1','6'],
        correctas18:['1','7'],
      },
      iguales:true,
      todasCorrectas:Array(2).fill(false),
    }
  },
  created() {
      var x = Math.floor((Math.random() * 8) + 1);
      this.onboardingC= x
      
  },
  watch: {
    currentText(){
      this.$store.commit('nextShow', true);
    },
    slideNumB(val){
      console.log('valueSlideB '+ val)
      this.respuestaActual.splice( 0, 1, val)
      console.log('this.respuestaActual '+ this.respuestaActual)
    },
    slideNumC(val){
      console.log('valueSlideC '+ val)
      this.respuestaActual.splice( 1, 1, val)
      console.log('this.respuestaActual '+ this.respuestaActual)
    }
  },
  methods: {
    bienAction(){
      this.onboardingC = 3
      if(this.casoNum == 17){
        this.$store.commit('nextShow', true);
      }else{
        this.casoNum += 1
        this.prevAction()
      }
      console.log('this.casoNum ' + this.casoNum)
    },
    enviarResultado(){
      var valcaso = this.casoNum
      console.log(valcaso)
      var respuestasActual = this.respuestasCorrectas['correctas'+(valcaso+1)+'']
      console.log(respuestasActual)

      for(var i=0;i< this.respuestaActual.length;i++){
        if(this.respuestaActual[i]!=respuestasActual[i]){
          this.iguales=false
        }
        var iguala = this.iguales
        if(iguala){
          this.$set(this.todasCorrectas,i,true)
          console.log(this.todasCorrectas)

        }
      }
      var todosVistos = this.todasCorrectas.every(el => {return el})
      if(todosVistos) {
        this.modalResultado = true
        this.modalResult = 'bien'
        this.iguales = true
        this.todasCorrectas = Array(2).fill(false)

      }else{
        console.log('INCORRECTA')
        this.modalResultado = true
        this.modalResult = 'mal'
        this.iguales = true
        this.todasCorrectas = Array(2).fill(false)
      }
    }  
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.cont-casos{
  border: solid $ibra-dark-blue 3px;
  padding: 2px;
  width: 200px;
  margin: 0 auto;
  border-radius: 10px;
  p{
    margin: 0;
    padding: 0;
    font-family: Poppins-BoldItalic;
    color: $ibra-dark-blue;
  }
  .desc{
    margin: 0;
    padding: 0;
    font-family: Poppins-Regular;
    color: $ibra-dark-blue;
    font-size: 15px;
  }
}

.cont-num{
  font-family: Poppins-Italic;
  font-size: 14px;
  color: $ibra-dark-blue;
  p{
    padding: 0;
    margin: 0;
  }
}

</style>
